import { Loader } from "@/components/animate-ui/icons/loader";

import { cn } from "@/lib/utils";

function Spinner({ className }: { className?: string }) {
	return (
		<Loader role="status" aria-label="Loading" className={cn("size-4 animate-spin", className)} />
	);
}

export { Spinner };
